import { lock, unlock } from 'tua-body-scroll-lock';
export default class NavEvent {
  constructor() {
    this.init();
  }
  init() {
    const toggles = document.querySelector('.js-NavToggle');
    const Nav = document.querySelector('.js-NavContent');

    toggles.addEventListener('click', (e) => {
      if (Nav.classList.contains('Act')) {
        unlock(Nav, { overflowType: 'clip' });
      } else {
        lock(Nav, { overflowType: 'clip' });
      }
      if (Nav.classList.contains('Act')) {
        Nav.classList.add('Hide');
        toggles.classList.add('Hide');
      } else {
        Nav.classList.remove('Hide');
        toggles.classList.remove('Hide');
      }
      Nav.classList.toggle('Act');
      toggles.classList.toggle('Act');
    });
  }
}
